<template>
  <div class="strategy-page-container" v-loading="loading">
    <!-- 有分组 -->
    <div v-if="groupedElinkList.length > 0">
      <div class="group-container">
        <div class="title-text">{{ $str.getKey('策略控制/联合调度分组') }}
          <span>
            <el-tooltip effect="light" :content="$str.getKey('策略控制/需量下发按照联合调度的分组进行设置，正常情况下同一个组下的eLink需量一致')" placement="left">
              <el-icon class="tip-icon">
                <Warning />
              </el-icon>
            </el-tooltip>
          </span>
        </div>
        <div class="group-blocks-container">
          <div v-for="(group, index) in groupedElinkList" :key="index" class="group-card"
            :class="{ 'active': selectedGroupIndex === index }" @click="selectGroup(index)">
            <div class="card-header">
              <span class="card-index" :class="{ 'active': selectedGroupIndex === index }">{{ group.groupIndex }}</span>
            </div>

            <div class="card-content">
              <div class="demand-row">
                <div class="demand-label">{{ $str.getKey('策略控制/整组需量') }}：</div>
                <template v-if="editingGroupIndex === index">
                  <div class="demand-input">
                    <el-input-number v-model="groupDemandValue" :min="0" :precision="0" size="small"
                      controls-position="right" @blur="checkGroupDemandValue" />
                  </div>
                  <div class="demand-actions">
                    <el-button round class="btn-confirm" @click.stop="onConfirmGroupDemand(index)">{{ $str.getKey('策略控制/确定') }}</el-button>
                    <el-button round class="btn-cancel" @click.stop="onCancelGroupDemand">{{ $str.getKey('策略控制/取消') }}</el-button>
                  </div>
                </template>
                <template v-else>
                  <div class="demand-value">{{ getGroupDemand(group) }}</div>
                  <div class="demand-actions">
                    <el-button round class="btn-modify" @click.stop="onEditGroupDemand(index)" :disabled="isGroupDemandDisabled()">{{ $str.getKey('策略控制/修改') }}</el-button>
                  </div>
                </template>
              </div>
            </div>
            <!-- 如果组内不同设备需量值不一样，则显示感叹号 -->
            <div v-if="group.flag">
              <el-icon>
                <Warning />
              </el-icon>
              <span>
                {{ $str.getKey('策略控制/该组设备可能存在异常') }}
              </span>
            </div>

            <div class="elink-buttons">
              <button v-for="eLink in group.eLinkSettingList" :key="eLink.uuid" class="elink-btn"
                :class="{ 'active': selectedELink === eLink.uuid }"
                @click.stop="onButtonClick(eLink.uuid, eLink.dev_id, getElinkName(eLink.uuid))">
                {{getBtnText(eLink.uuid,eLink.demandMax,group.flag)}}
               
              </button>
            </div>
          </div>

        </div>
      </div>

      <div class="main-container main-container-group" v-if="currentGroupElinkList.length > 0">
        <!-- 左侧内容 -->
        <div class="left-container" :class="appStore.strategySwitch ? 'switch-on' : 'switch-off'">
          <!-- 是否打开了【策略控制】开关: yes -->
          <div v-if="appStore.strategySwitch">
            <!-- 图表上方的info&operate控件 -->
            <div class="chart-info-container">
              <div class="infos">
                <span class="title-text">{{ $str.getKey('策略控制/当前选择') }}：{{ currentELinkData?.elink_name }}</span>
                <span class="title-text">{{ today }}&nbsp;&nbsp;{{ emindStrategyName }}</span>
                <StrategyState :state="syncStatus"></StrategyState>
              </div>
              <div class="operate-btns">
                <el-button round plain :icon="Promotion" @click="pushStrategy">{{ $str.getKey('策略控制/推送') }}</el-button>
                <el-button round plain :icon="Finished" @click="onCompare">
                  {{ strategyState.isCompare ? $str.getKey('策略控制/取消对比') : $str.getKey('策略控制/对比') }}
                </el-button>
              </div>
            </div>

            <!-- 图表 - 对比状态 -->
            <div class="chart-container is-compare chart-bepartof-group" v-if="strategyState.isCompare">
              <div class="chart-comp">
                <StrategyChart :currentELinkData="currentELinkData"></StrategyChart>
              </div>
              <div class="chart-comp">
                <StrategyChart :currentELinkData="currentELinkData" is-elink></StrategyChart>
              </div>
            </div>
            <!-- 图表 - 非对比状态 -->
            <!-- 图表 - 非对比状态 -->
            <div class="chart-container no-compare chart-bepartof-group" v-else>
              <v-chart :option="option" :autoresize="true"></v-chart>
            </div>
          </div>
          <!-- 是否打开了【策略控制】开关: not -->
          <div v-else>
            <StrategyChart :currentELinkData="currentELinkData" is-elink></StrategyChart>
          </div>
        </div>

        <!-- 右侧菜单 -->
        <div class="right-container right-container-for-group" v-if="appStore.strategySwitch">
          <div class="title-text">{{ $str.getKey('策略控制/功能菜单') }}</div>
          <!-- 需量历史 -->
          <div class="module-card" v-if="autoDemand">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/需量历史') }}</div>
              <div class="value"></div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">{{ $str.getKey('策略控制/查看历史需量变更记录及操作日志') }}</div>
              <div class="interaction">
                <el-button round class="inter-btn" @click="demandHistoryDrawerVisible = true">详情</el-button>
              </div>
            </div>
          </div>

          <!-- 充放电模式 -->
          <div class="module-card" v-if="checkPermi(['ops:strategyControl:config'])">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/充放电模式') }}</div>
              <div class="value"></div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">{{ $str.getKey('策略控制/设置电站的工作日/休息日模式,如无休、单休或双休') }}</div>
              <div class="interaction">
                <el-button round class="inter-btn" @click="onEditChargeMode">修改</el-button>
              </div>
            </div>
          </div>

          <!-- 第三方调度 -->
          <div class="module-card" v-if="checkPermi(['ops:strategyControl:config'])">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/第三方调度') }}</div>
              <div class="value"></div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">{{ $str.getKey('策略控制/设置是否允许虚拟电厂进行第三方调度控制') }}</div>
              <div class="interaction">
                <el-switch v-model="strategyInfo.allowVirtualDispatch" @change="onSwitchBeforeChange" :loading="strategyState.allowDispatchLoading" />
              </div>
            </div>
          </div>

          <!-- 运行策略 -->
          <div class="module-card" v-if="checkPermi(['ops:strategyControl:config'])">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/运行策略') }}</div>
              <div class="value"></div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">{{ $str.getKey('策略控制/设置电站的充放电策略,包括工作日策略、是否防逆流和休息日策略、是否防逆流') }}</div>
              <div class="interaction">
                <el-button round class="inter-btn" @click="openRunStrategy()">详情</el-button>
              </div>
            </div>
          </div>

          <!-- 预约策略 -->
          <div class="module-card" v-if="checkPermi(['ops:strategyControl:appoint'])">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/预约策略') }}</div>
              <div class="value"></div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">{{ $str.getKey('策略控制/设置预约生效的策略,可指定日期后自动切换生效') }}</div>
              <div class="interaction">
                <el-button round class="inter-btn" @click="openApproiveStrategy()">详情</el-button>
              </div>
            </div>
          </div>

          <!-- 日历视图 -->
          <div class="module-card">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/日历视图') }}</div>
              <div class="value"></div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">{{ $str.getKey('策略控制/通过日历形式查看每日的策略安排及执行情况') }}</div>
              <div class="interaction">
                <el-button round class="inter-btn" @click="strategyState.calendarViewDrawerVisible = true">详情</el-button>
              </div>
            </div>
          </div>

          <!-- 策略历史 -->
          <div class="module-card" v-if="checkPermi(['ops:strategyControl:config'])">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/策略历史') }}</div>
              <div class="value"></div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">{{ $str.getKey('策略控制/查看历史策略变更记录及操作日志') }}</div>
              <div class="interaction">
                <el-button round class="inter-btn" @click="strategyState.strategyHistoryDrawerVisible = true">详情</el-button>
              </div>
            </div>
          </div>

          <div class="moudle-gather-container" v-if="false">
            <!-- 运行策略 -->
            <el-button round class="module-enter-btn" v-if="checkPermi(['ops:strategyControl:config'])" @click="openRunStrategy()">
              <div class="btn-wrapper">
                <img class="module-icon" :src="IcStategy" alt="">
                <div class="module-title-container">
                  <div class="title-text">{{ $str.getKey('策略控制/运行策略') }}</div>
                  <el-tooltip effect="light" :content="$str.getKey('策略控制/设置电站的充放电策略,包括工作日策略、是否防逆流和休息日策略、是否防逆流')" placement="top">
                    <el-icon> <Warning /> </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-button>

            <!-- 预约策略 -->
            <el-button round class="module-enter-btn" v-if="checkPermi(['ops:strategyControl:appoint'])" @click="openApproiveStrategy()">
              <div class="btn-wrapper">
                <img class="module-icon" :src="IcYyue" alt="">
                <div class="module-title-container">
                  <div class="title-text">{{ $str.getKey('策略控制/预约策略') }}</div>
                  <el-tooltip effect="light" :content="$str.getKey('策略控制/设置预约生效的策略,可指定日期后自动切换生效')" placement="top">
                    <el-icon> <Warning /> </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-button>

            <!-- 日历视图 -->
            <el-button round class="module-enter-btn" @click="strategyState.calendarViewDrawerVisible = true">
              <div class="btn-wrapper">
                <img class="module-icon" :src="IcCalendar" alt="">
                <div class="module-title-container">
                  <div class="title-text">{{ $str.getKey('策略控制/日历视图') }}</div>
                  <el-tooltip effect="light" :content="$str.getKey('策略控制/通过日历形式查看每日的策略安排及执行情况')" placement="bottom">
                    <el-icon> <Warning /> </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-button>

            <!-- 策略历史 -->
            <el-button round class="module-enter-btn" v-if="checkPermi(['ops:strategyControl:config'])" @click="strategyState.strategyHistoryDrawerVisible = true">
              <div class="btn-wrapper">
                <img class="module-icon" :src="IcHistory" alt="">
                <div class="module-title-container">
                  <div class="title-text">{{ $str.getKey('策略控制/策略历史') }}</div>
                  <el-tooltip effect="light" :content="$str.getKey('策略控制/查看历史策略变更记录及操作日志')" placement="bottom">
                    <el-icon> <Warning /> </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-button>
          </div>
        </div>
      </div>
      <!-- <div class="main-container" v-else-if="loading" v-loading="loading" :element-loading-text="$str.getKey('策略控制/加载中...')"></div> -->
      <el-empty class="main-container" v-else-if="!loading" :image="noDataIcon"></el-empty>

    </div>
    <!-- 无分组 --> 
    <div v-else>
      <div class="top-container">
        <div class="title-text">eLink</div>
        <div class="tab-btns-container">
          <el-button round size="small" :disabled="syncing" class="strategy-btn" v-for="eLink in eLinkList"
            :key="eLink.elink_id" v-bind="getButtonAttrs(eLink.elink_id)"
            @click="onButtonClick(eLink.elink_id, eLink.dev_id, eLink?.elink_name)">{{
              eLink?.elink_name }}</el-button>
        </div>
      </div>
      <div class="main-container main-container-notgroup" v-if="eLinkList.length > 0">
        <!-- 是否打开了【策略控制】开关: yes -->
        <div class="left-container switch-on" v-if="appStore.strategySwitch">
          <!-- 图表上方的info&operate控件 -->
          <div class="chart-info-container">
            <div class="infos">
              <span class="title-text">{{ today }}&nbsp;&nbsp;{{ emindStrategyName }}</span>
              <StrategyState :state="syncStatus"></StrategyState>
            </div>
            <div class="operate-btns">
              <el-button round plain :icon="Promotion" @click="pushStrategy">{{ $str.getKey('策略控制/推送') }}</el-button>
              <el-button round plain :icon="Finished" @click="onCompare">
                {{ strategyState.isCompare ? $str.getKey('策略控制/取消对比') : $str.getKey('策略控制/对比') }}
              </el-button>
            </div>
          </div>

          <!-- 图表 - 对比状态 -->
          <div class="chart-container is-compare" v-if="strategyState.isCompare">
            <div class="chart-comp">
              <StrategyChart :currentELinkData="currentELinkData"></StrategyChart>
            </div>
            <div class="chart-comp">
              <StrategyChart :currentELinkData="currentELinkData" is-elink></StrategyChart>
            </div>
          </div>
          <!-- 图表 - 非对比状态 -->
          <div class="chart-container no-compare" v-else>
            <v-chart :option="option" :autoresize="true"></v-chart>
          </div>
        </div>
        <!-- 是否打开了【策略控制】开关: not -->
        <div class="left-container switch-off" v-else>
          <StrategyChart :currentELinkData="currentELinkData" is-elink></StrategyChart>
        </div>
        <div class="right-container right-container-notfor-group" v-if="appStore.strategySwitch">
          <div class="title-text">{{ $str.getKey('策略控制/策略信息') }}</div>

          <!-- 需量 -->
          <div class="module-card edit-container" v-if="strategyState.isEdit">
            <el-input-number :placeholder="$str.getKey('策略控制/请输入需量')" v-model="strategyState.inputDemand" :max="99999999999" :min="0"
              @blur="checkInputDemand" controls-position="right" class="input-dom"></el-input-number>
            <div class="btns">
              <el-button plain @click="onCancelEditDemand" class="btn">{{ $str.getKey('策略控制/取消') }}</el-button>
              <el-button plain @click="onConfirmDemand" class="btn">{{ $str.getKey('策略控制/确定') }}</el-button>
            </div>
          </div>
          <div class="module-card" v-else>
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/需量') }}</div>
              <div class="value">{{ strategyInfo.demand }}kW</div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">
                <span>{{ $str.getKey('策略控制/参考需量') }}: {{ strategyInfo.refDemand }}kW</span>
                <el-tooltip effect="light" :content="$str.getKey('策略控制/参考需量根据关口电表的历史数据预测,请在设置需量时根据实际情况酌情设置')" placement="top">
                  <el-icon class="cursor-pointer tip-icon">
                    <WarningFilled />
                  </el-icon>
                </el-tooltip>
              </div>
              <div class="interaction">
                <el-button round class="inter-btn" @click="onEditDemand" :disabled="!checkPermi(['ops:strategyControl:config']) || !appStore.strategySwitch">{{ $str.getKey('策略控制/修改') }}</el-button>
              </div>
            </div>
          </div>

          <!-- 当前充放电模式 -->
          <div class="module-card">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/当前充放电模式') }}</div>
              <div class="value">{{ strategyInfo.chargeModeDesc }}</div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info">{{ strategyInfo.chargeModeDetail }}</div>
              <div class="interaction">
                <el-button round class="inter-btn" @click="onEditChargeMode" :disabled="!checkPermi(['ops:strategyControl:config']) || !appStore.strategySwitch">{{ $str.getKey('策略控制/修改') }}</el-button>
              </div>
            </div>
          </div>

          <!-- 虚拟电厂调度 -->
          <div class="module-card">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/虚拟电厂调度') }}</div>
              <div class="value">{{ strategyInfo.allowVirtualDispatch ? $str.getKey('策略控制/允许') : $str.getKey('策略控制/禁止') }}</div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info"></div>
              <div class="interaction">
                <el-switch :disabled="!checkPermi(['ops:strategyControl:config']) || !appStore.strategySwitch"
                  v-model="strategyInfo.allowVirtualDispatch" @change="onSwitchBeforeChange"
                  :loading="strategyState.allowDispatchLoading"></el-switch>
              </div>
            </div>
          </div>

          <!-- 防逆流 -->
          <div class="module-card">
            <div class="content-row main-row">
              <div class="title">{{ $str.getKey('策略控制/防逆流') }}</div>
              <div class="value">{{ antiReflux ? $str.getKey('策略控制/开启') : $str.getKey('策略控制/关闭') }}</div>
            </div>
            <div class="content-row sub-row">
              <div class="desc-info"></div>
              <div class="interaction">
                <el-switch :disabled="!checkPermi(['ops:strategyControl:config'])" v-model="antiReflux"
                  @change="onSwitchBeforeChangeAntiReflux" :loading="antiRefluxLoading"></el-switch>
              </div>
            </div>
          </div>


          <div class="moudle-gather-container">
            <!-- 运行策略 -->
            <el-button round class="module-enter-btn" v-if="checkPermi(['ops:strategyControl:config'])" @click="openRunStrategy()">
              <div class="btn-wrapper">
                <img class="module-icon" :src="IcStategy" alt="">
                <div class="module-title-container">
                  <div class="title-text">{{ $str.getKey('策略控制/运行策略') }}</div>
                  <el-tooltip effect="light" :content="$str.getKey('策略控制/设置电站的充放电策略,包括工作日策略、是否防逆流和休息日策略、是否防逆流')" placement="top" v-if="false">
                    <el-icon> <Warning /> </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-button>

            <!-- 预约策略 -->
            <el-button round class="module-enter-btn" v-if="checkPermi(['ops:strategyControl:appoint'])" @click="openApproiveStrategy()">
              <div class="btn-wrapper">
                <img class="module-icon" :src="IcYyue" alt="">
                <div class="module-title-container">
                  <div class="title-text">{{ $str.getKey('策略控制/预约策略') }}</div>
                  <el-badge class="badge-tip" :value="customStrategys.length" :max="5" ></el-badge>
                  <!-- <el-tooltip effect="light" :content="$str.getKey('策略控制/设置预约生效的策略,可指定日期后自动切换生效')" placement="top"> -->
                  <el-tooltip effect="light" :content="`当前生效：${currentEffectivePlan.currentName ? currentEffectivePlan.currentName : ''}  ${currentEffectivePlan.hasNext ? currentEffectivePlan.nextText : ''}`" placement="top">
                    <el-icon> <Warning /> </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-button>

            <!-- 日历视图 -->
            <el-button round class="module-enter-btn" @click="strategyState.calendarViewDrawerVisible = true">
              <div class="btn-wrapper">
                <img class="module-icon" :src="IcCalendar" alt="">
                <div class="module-title-container">
                  <div class="title-text">{{ $str.getKey('策略控制/日历视图') }}</div>
                  <el-tooltip effect="light" :content="$str.getKey('策略控制/通过日历形式查看每日的策略安排及执行情况')" placement="bottom" v-if="false">
                    <el-icon> <Warning /> </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-button>

            <!-- 策略历史 -->
            <el-button round class="module-enter-btn" v-if="checkPermi(['ops:strategyControl:config'])" @click="strategyState.strategyHistoryDrawerVisible = true">
              <div class="btn-wrapper">
                <img class="module-icon" :src="IcHistory" alt="">
                <div class="module-title-container">
                  <div class="title-text">{{ $str.getKey('策略控制/策略历史') }}</div>
                  <el-tooltip effect="light" :content="$str.getKey('策略控制/查看历史策略变更记录及操作日志')" placement="bottom" v-if="false">
                    <el-icon> <Warning /> </el-icon>
                  </el-tooltip>
                </div>
              </div>
            </el-button>
          </div>

        </div>
      </div>
      <!-- <div class="main-container" v-else-if="loading" v-loading="loading" :element-loading-text="$str.getKey('策略控制/加载中...')"></div> -->
      <el-empty class="main-container" v-else-if="!loading" :image="noDataIcon"></el-empty>
    </div>

  </div>

  <!-- ====== 抽屉：修改当前充放电模式 ======================================================================================================================== -->
  <el-drawer v-model="strategyState.chargeModeDrawerVisible" direction="rtl" append-to-body :title="$str.getKey('策略控制/充放电模式')" class="cus-drawer-20241114-143756">
    <ChargeModeCardGroup v-model="strategyState.inputChargeMode">
      <ChargeModeCard :title="$str.getKey('策略控制/无休')" :subtitle="$str.getKey('策略控制/所有日期都执行工作日策略')" value="0" color="#EC522A"></ChargeModeCard>
      <ChargeModeCard :title="$str.getKey('策略控制/单休')" :subtitle="$str.getKey('策略控制/周日执行休息日策略,其他时间执行工作日策略')" value="1" color="#3A68FF"></ChargeModeCard>
      <ChargeModeCard :title="$str.getKey('策略控制/双休')" :subtitle="$str.getKey('策略控制/周六和周日执行休息日策略,其他时间执行工作日策略')" value="2" color="#36B60C"></ChargeModeCard>
    </ChargeModeCardGroup>
    <template #footer>
      <el-button @click="onChargeModeCancel">{{ $str.getKey('策略控制/取消') }}</el-button>
      <el-button type="primary" @click="onChargeModeConfirm">{{ $str.getKey('策略控制/确定') }}</el-button>
    </template>
  </el-drawer>

  <!-- ====== 抽屉：运行策略 ======================================================================================================================== -->
  <el-drawer v-model="strategyState.runStrategyDrawerVisible" direction="rtl" append-to-body destroy-on-close :title="$str.getKey('策略控制/运行策略管理')" class="cus-drawer-20241114-143756 run-strategy-drawer" @open="resetRunStrategyScroll" @opened="resetRunStrategyScroll" @close="resetRunStrategyScroll" @closed="resetRunStrategyScroll">
    <StrategyEditor ref="sEditRef" v-model:isEdit="strategyState.runStateIsEdit"
      :isElinkGroup="groupedElinkList.length > 0" :currentELinkData="currentELinkData" :hasPvAccess="hasPvAccess"></StrategyEditor>
    <template #footer>
      <el-button @click="onRunStrategyCancel" v-if="strategyState.runStateIsEdit">{{ $str.getKey('策略控制/取消') }}</el-button>
      <el-button @click="strategyState.runStrategyDrawerVisible = false" v-else>{{ $str.getKey('全局/关闭') }}</el-button>
      <el-button type="primary" @click="onRunStrategyConfirm" v-if="strategyState.runStateIsEdit">{{ $str.getKey('策略控制/保存') }}</el-button>
    </template>
  </el-drawer>


  <!-- ====== 抽屉：预约策略 ======================================================================================================================== -->
  <el-drawer v-model="strategyState.appointmentDrawerVisible" direction="rtl" append-to-body :title="$str.getKey('策略控制/预约策略')"
    class="cus-drawer-20241114-143756 appointment-drawer">
    <el-scrollbar height="100%">
      <div class="appointment-wrapper">
        <el-alert show-icon :title="$str.getKey('策略控制/各项参数以及运行策略将会在指定日期之后生效')" :closable="false"></el-alert>
        <!-- 预约策略的卡片 -->
        <div class="cards-container">
          <div class="card" v-for="(item, index) in appointmentList" :key="item.id">
            <AppointmentCard :strategy-data="item" :appointmentList="appointmentList" :iconImg="getIconImg(index)" :autoDemand="autoDemand"
              @remove="onAppointmentRemove" @cancelEdit="onAppointmentCancelEdit"
              @save="updateCustomStrategys"></AppointmentCard>
          </div>
          <div class="add-card" @click="addAppointment">
            <div class="add-img"></div>
            <div class="add-text">{{ $str.getKey('策略控制/新增计划') }}</div>
          </div>
        </div>
      </div>
    </el-scrollbar>

    <template #footer v-if="false">
      <el-button @click="onAppointmentCancel">{{ $str.getKey('全局/关闭') }}</el-button>
      <!-- <el-button type="primary" @click="onAppointmentConfirm">确定</el-button> -->
    </template>
  </el-drawer>

  <!-- ====== 抽屉：日历视图 ======================================================================================================================== -->
  <el-drawer v-model="strategyState.calendarViewDrawerVisible" direction="rtl" append-to-body :title="$str.getKey('策略控制/日历视图')" class="cus-drawer-20241114-143756">
    <StrategyCalendar :currentELinkData="currentELinkData" @switch-strategy="updateELinks"
      :customStrategys="customStrategys"></StrategyCalendar>
    <template #footer v-if="false">
      <el-button @click="strategyState.calendarViewDrawerVisible = false">{{ $str.getKey('全局/关闭') }}</el-button>
    </template>
  </el-drawer>

  <!-- ====== 抽屉：策略历史 ======================================================================================================================== -->
  <el-drawer v-model="strategyState.strategyHistoryDrawerVisible" direction="rtl" append-to-body :title="$str.getKey('策略控制/策略历史')" class="cus-drawer-20241114-143756">
    <StrategyHistoryComp :elinkId="selectedELink" :hasPvAccess="hasPvAccess"
      v-if="strategyState.strategyHistoryDrawerVisible"></StrategyHistoryComp>
    <template #footer v-if="false">
      <el-button @click="strategyState.strategyHistoryDrawerVisible = false">{{ $str.getKey('全局/关闭') }}</el-button>
    </template>
  </el-drawer>

  <!-- 需量历史弹框 -->
  <el-drawer v-model="demandHistoryDrawerVisible" direction="rtl" append-to-body :title="$str.getKey('策略控制/需量历史')" class="cus-drawer-20241114-143756">
    <DemandHistoryComp :stationId="stationId" :uuid='selectedELink' v-if="demandHistoryDrawerVisible"></DemandHistoryComp>
  </el-drawer>

</template>


<script setup>
import { computed, nextTick, provide, reactive, ref, watch, getCurrentInstance, onMounted, resolveComponent } from 'vue'
import dayjs from 'dayjs'
import { ElMessageBox } from 'element-plus'
import { Calendar, Finished, Menu, Operation, Plus, Promotion, WarningFilled, } from '@element-plus/icons-vue'
import VChart from 'vue-echarts'

import StrategyCard from './pageParts/StrategyCard.vue'
import StrategyEditor from './pageParts/StrategyEditor.vue'
import AppointmentCard from './pageParts/AppointmentCard.vue'
import ChargeModeCardGroup from './pageParts/ChargeModeCardGroup.vue'
import ChargeModeCard from './pageParts/ChargeModeCard.vue'
import StrategyState from './pageParts/StrategyState.vue'
import StrategyCalendar from './pageParts/StrategyCalendar.vue'
import StrategyHistoryComp from './pageParts/StrategyHistoryComp.vue'
import StrategyChart from './pageParts/StrategyChart.vue'
import DemandHistoryComp from './pageParts/DemandHistoryComp.vue'

import {
  createOption,
  cur_elk,
  minutesOfDay,
  strategyData2UnderscoreCase,
  strategyNameFromType,
  timeToMinutes,
  Appointment,
  toBinStr,
  compareStrategy,
  calculationStrategyType,
  translateThirdCtrl,
  translateResultCode,
  formmatTime,
  cloneDeep,
  checkPermi,
} from "./utils"
import * as strategyApi from './api.js';
import { clearSmsCode } from './smsCodeStore'

import useAppStore from '@/store/modules/app'
import useUserStore from '@/store/modules/user'

import IcOther from '@/assets/images/strategy/ic_other.png'
import IcMode from '@/assets/images/strategy/ic_mode.png'
import IcYyue from '@/assets/images/strategy/ic_yuyue.svg'
import IcStategy from '@/assets/images/strategy/ic_stategy.svg'
import IcCalendar from '@/assets/images/strategy/ic_calad.svg'
import IcHistory from '@/assets/images/strategy/ic_history.svg'
import icon0 from "@/assets/images/strategy/icon1600.png";
import icon1 from "@/assets/images/strategy/icon1601.png";
import icon2 from "@/assets/images/strategy/icon1602.png";
import noDataIcon from "@/assets/images/strategy/noData.png";
import { reject, result } from 'lodash-es'


const $str = window.$str;


const { proxy } = getCurrentInstance()
const appStore = useAppStore()
const userStore = useUserStore()
const stationId = computed(() => {
  console.log('dev---: appStore.stationId = ', appStore.stationId)
  return appStore.stationId;
})

const sEditRef = ref(null)
const today = dayjs().format('YYYY-MM-DD')
const selectedELink = ref(''); // 记录当前eLink的UU_Id
const selectedELinkDevId = ref(''); // 记录当前eLink的dev_Id
const selectedELinkName = ref(''); // 记录当前eLink的name
const eLinkList = ref([])
const loading = ref(false);

// 分组相关
const groupedElinkList = ref([])
const selectedGroupIndex = ref(0)
const currentGroupElinkList = computed(() => {
  if (groupedElinkList.value.length > 0 && selectedGroupIndex.value < groupedElinkList.value.length) {
    return groupedElinkList.value[selectedGroupIndex.value].eLinkSettingList || []
  }
  return []
})



// 分组需量编辑相关状态
const editingGroupIndex = ref(null)
const groupDemandValue = ref(0)

const currentELinkData = computed(() => {
  return getCurrentELinkData()
})

const hasPvAccess = computed(() => {
  const access = appStore.currentStation?.pvAccess
  return access === true || access === 1 || access === '1'
})

appStore.getStations(); // 进入策略管理页面时,刷新stations并更新到缓存,以便获取每个站最新的strategySwitch
provide(cur_elk, currentELinkData)
onMounted(() => {
  // strategyState.runStrategyDrawerVisible = true;
})

const option = computed(() => {
  let emindStrategy = getEMindStrategyData()
  let opt = createOption(emindStrategy, currentELinkData.value?.powerLimit)
  return opt

})

const emindStrategyName = computed(() => {
  if (currentELinkData.value) {
    return strategyNameFromType(currentELinkData.value.strategy_type)
  }
})

const syncing = ref(false)
const syncStatus = computed(() => {
  if (syncing.value) {
    return 3
  }
  const isSync = getSyncStatus()
  return isSync ? 1 : 2
})

const strategyState = reactive({
  isCompare: localStorage.getItem('eMind.isCompare') === 'true',
  isEdit: false,
  runStateIsEdit: false,
  chargeModeDrawerVisible: false,
  runStrategyDrawerVisible: false,
  appointmentDrawerVisible: false,
  calendarViewDrawerVisible: false,
  strategyHistoryDrawerVisible: false,
  communicationModeDrawerVisible: false, // 通信中断储能运行模式抽屉
  inputDemand: '',
  inputChargeMode: 1,
  allowDispatchLoading: false,
})

const Models = {
  0: $str.getKey('策略控制/无休'),
  1: $str.getKey('策略控制/单休'),
  2: $str.getKey('策略控制/双休')
}

const ModelsDetail = {
  0: $str.getKey('策略控制/所有日期都执行工作日策略'),
  1: $str.getKey('策略控制/周日执行休息日策略,其他时间执行工作日策略'),
  2: $str.getKey('策略控制/周六和周日执行休息日策略,其他时间执行工作日策略')
}

const strategyInfo = reactive({
  demand: computed(() => {
    return currentELinkData.value?.demand || '--'
  }),
  refDemand: computed(() => {
    return currentELinkData.value?.reference_demand || '--'
  }),
  chargeMode: computed(() => {
    return currentELinkData.value?.week_plan || 0
  }),
  allowVirtualDispatch: false,
  communicationMode: 1, // 通信中断储能运行模式: 1-按策略一直运行, 2-按策略运行第二天停机, 3-按策略工作休息制度运行
  communicationModeDesc: computed(() => {
    switch (strategyInfo.communicationMode) {
      case 1: return $str.getKey('策略控制/按策略一直运行');
      case 2: return $str.getKey('策略控制/第二天停机');
      case 3: return $str.getKey('策略控制/工作休息制度');
      default: return $str.getKey('策略控制/按策略一直运行');
    }
  }),
  chargeModeDesc: computed(() => {
    return Models[strategyInfo.chargeMode]
  }),
  chargeModeDetail: computed(() => {
    return ModelsDetail[strategyInfo.chargeMode]
  }),
})

const appointmentList = ref([])

const autoDemand = ref(false)

function isGroupDemandDisabled() {
  if (autoDemand.value) return true
  return !checkPermi(['ops:strategyControl:config'])
}

// 获取配置时赋值为布尔
strategyApi.getStationStrategyConfig(stationId.value).then(res => {
  if (res.code == 200 && res.data) {
    autoDemand.value = res.data.autoDemand === 1
  }
})

/**
 * 获取当前选择的eLink策略数据
 */
function getCurrentELinkData() {
  const list = eLinkList.value || []
  return list.find(elk => elk.elink_id === selectedELink.value)
}


function getEMindStrategyData() {
  let current = getCurrentELinkData()
  if (current) {
    if (current.strategy_type === 'work') {
      return current.strategys_work
    } else if (current.strategy_type === 'rest') {
      return current.strategys_rest
    }
  }
}


function getButtonAttrs(value) {
  if (selectedELink.value === value) {
    return {
      type: 'primary',
      round: true,
    }
  }
  return {
    text: true,
    type: '',
  }
}

function onButtonClick(id, devId, elinkName) {
  // 设置选中的eLink信息
  selectedELink.value = id
  selectedELinkDevId.value = devId
  selectedELinkName.value = elinkName

  // 如果有分组,则查找eLink所在的分组并设置
  if (groupedElinkList.value.length > 0) {
    // 查找eLink所在的分组索引
    for (let i = 0; i < groupedElinkList.value.length; i++) {
      const group = groupedElinkList.value[i]
      // 检查此eLink是否在当前分组中
      const isInGroup = group.eLinkSettingList.some(eLink => eLink.uuid === id)
      if (isInGroup) {
        // 找到所在分组,设置selectedGroupIndex
        selectedGroupIndex.value = i
        break
      }
    }
  }
}


function onEditDemand() {
  strategyState.isEdit = true
  strategyState.inputDemand = +strategyInfo.demand
}

function onCancelEditDemand() {
  strategyState.isEdit = false
}

function onConfirmDemand() {
  if (strategyState.inputDemand <= 0) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/需量必须大于0')
    });
    return
  }

  let elk = {
    id: currentELinkData.value.id,
    elink_id: selectedELink.value,
    demand: strategyState.inputDemand,
    station_id: appStore.stationId,
    opt_user: userStore.name,
  }

  strategyApi.updatePlan(elk).then((res) => {
    if (res.code == 200) {
      window.dispatchNotify({
        type: 'success',
        message: $str.getKey('策略控制/需量修改成功')
      });
      pullStrategy()
      strategyState.isEdit = false
    } else {
      window.dispatchNotify({
        type: 'error',
        message: res.msg
      });
    }
  })
}


function onEditChargeMode() {
  strategyState.chargeModeDrawerVisible = true
  strategyState.inputChargeMode = strategyInfo.chargeMode
}

function openRunStrategy() {
  // 确保已选择eLink
  if (!selectedELink.value) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/请先选择eLink')
    });
    return;
  }

  const demand = Number(strategyInfo.demand)
  if (Number.isNaN(demand) || demand === 0) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/请先设置需量')
    });
    return
  }
  strategyState.runStrategyDrawerVisible = true
  // 抽屉带 destroy-on-close，内容是本次打开才挂载的，
  // 首个 nextTick 拿不到 ref 时再等一帧，避免策略数据没回填
  const initEditor = (retry = true) => {
    if (sEditRef.value) {
      sEditRef.value.updateLocalStrategy()
      sEditRef.value.exitEdit()
    } else if (retry) {
      nextTick(() => initEditor(false))
      return
    }
    resetRunStrategyScroll() // 每次打开时滚动条回到顶部
  }
  nextTick(() => initEditor())
}

/** 运行策略抽屉每次打开时，把滚动条重置到顶部（抽屉不销毁，否则会沿用上次的滚动位置） */
function resetRunStrategyScroll() {
  const reset = () => {
    const drawer = document.querySelector('.run-strategy-drawer')
    if (!drawer) return
    // 抽屉 body、编辑器内容区等都可能是滚动容器，逐个归零
    drawer.querySelectorAll('*').forEach(el => {
      if (el.scrollTop || el.scrollLeft) {
        el.scrollTop = 0
        el.scrollLeft = 0
      }
    })
    drawer.scrollTop = 0
    sEditRef.value?.scrollToTop?.()
  }
  // 抽屉有展开动画，内容高度是逐帧变化的，只在当前帧归零会被后续布局还原，
  // 因此动画期间多归零几次
  nextTick(reset)
  requestAnimationFrame(() => {
    reset()
    requestAnimationFrame(reset)
  })
  setTimeout(reset, 120)
  setTimeout(reset, 360)
}


const customStrategys = ref([])

const currentEffectivePlan = computed(() => {
  const beforeToday = []
  const afterToday = []
  // beforeToday
  let today = dayjs().startOf('day')
  for (const item of customStrategys.value) {
    let t = dayjs(item.execution_time)
    if (t.valueOf() <= today.valueOf()) {
      beforeToday.push(item)
    } else {
      afterToday.push(item)
    }
  }
  const next = afterToday[0] || {}
  const dayDistance = dayjs(next.execution_time).diff(today, 'day')

  return {
    current: beforeToday.at(-1),
    currentName: beforeToday.at(-1)?.custom_strategy_name,
    hasNext: afterToday.length > 0,
    nextText: $str.getKey('策略控制/距离') + `"${next.custom_strategy_name}"` + $str.getKey('策略控制/生效还有') + `${dayDistance}` + $str.getKey('策略控制/天')
  }
})


/**
 * 打开预约策略
 */
async function openApproiveStrategy() {
  // 确保已选择eLink
  if (!selectedELink.value) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/请先选择eLink')
    });
    return;
  }

  strategyState.appointmentDrawerVisible = true

  try {
    // 先获取最新的自定义策略数据
    await updateCustomStrategys()
    appointmentList.value = cloneDeep(customStrategys.value)
  } catch (error) {
    console.error('获取预约策略失败:', error)
    appointmentList.value = []
  }
}


async function updateCustomStrategys() {
  const res = await strategyApi.getCustomStrategy(selectedELink.value)
  customStrategys.value = res.data

  customStrategys.value.forEach(s => {
    s.disabled = true
  })

  appointmentList.value = cloneDeep(customStrategys.value)
}

const flag = ref(true)
/**
 * 判断是否有分组,根据分组列表判断eLink列表
 */
async function updateELinks() {

  try {
    loading.value = true;
    // 获取eLink列表
    const elinkData = await strategyApi.elinks(stationId.value)
    eLinkList.value = elinkData.data || [];



    // 获取分组列表
    const res = await strategyApi.getGroupSettingList(stationId.value);
    groupedElinkList.value = res.data || [];

    // 判断每个组内的demandMax值是否都一样
    // 遍历所有组，为每个组添加flag属性
    if (groupedElinkList.value && groupedElinkList.value.length > 0) {
      groupedElinkList.value.forEach(group => {
        // 初始化判断标志为true，假设所有值都相同
        let isDemandMaxSame = true;
        
        // 只有当组内有多个elink时才需要判断
        if (group.eLinkSettingList && group.eLinkSettingList.length > 1) {
          // 获取第一个链路的demandMax作为参考值
          const firstDemandMax = group.eLinkSettingList[0].demandMax;
          
          // 遍历组内所有elink
          for (let i = 1; i < group.eLinkSettingList.length; i++) {
            // 如果有任何一个demandMax与参考值不同，则设置标志为false
            if (group.eLinkSettingList[i].demandMax !== firstDemandMax) {
              isDemandMaxSame = false;
              break;
            }
          }
        }
        
        // 设置该组的flag属性，当值不同时flag为true（注意这里是反的）
        group.flag = !isDemandMaxSame;
      });
    }

  } catch (err) {
    console.error(err);
  } finally {
    loading.value = false;
  }
}


async function selectFirst() {
  const list = groupedElinkList.value || []
  if (list.length > 0) {
    // 先选择第一个分组
    selectedGroupIndex.value = 0;
    const firstGroup = list[0];

    // 再选择该分组的第一个eLink
    if (firstGroup.eLinkSettingList && firstGroup.eLinkSettingList.length > 0) {
      const firstELink = firstGroup.eLinkSettingList[0];
      onButtonClick(firstELink.uuid, firstELink.dev_id, getElinkName(firstELink.uuid));
    }
  } else if (eLinkList.value.length > 0) {
    // 无分组时,选择第一个eLink
    const firstELink = eLinkList.value[0];
    onButtonClick(firstELink.elink_id, firstELink.dev_id, firstELink.elink_name);
  }
}

function onCompare() {
  strategyState.isCompare = !strategyState.isCompare
  localStorage.setItem('eMind.isCompare', strategyState.isCompare + '')
}


async function pushStrategy() {
  if (!strategyInfo.demand) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/请先设置需量')
    });
  } else {
    try {
      await strategyApi.strategyDown(selectedELink.value)
      window.dispatchNotify({
        type: 'success',
        message: $str.getKey('策略控制/推送成功'),
      });
      pullStrategy()
    } catch (error) {
      window.dispatchNotify({
        type: 'error',
        message: $str.getKey('策略控制/推送失败!') + error
      });
    }
  }
}


let timer

function pullStrategy() {
  clearTimeout(timer)
  let updateCount = 5
  syncing.value = true
  //
  const update = async () => {
    updateCount--
    await updateELinks()
    const isSync = getSyncStatus()

    if (!isSync && updateCount > 0) {
      timer = setTimeout(() => {
        update()
      }, 1000);
    } else {
      syncing.value = false
    }
  }

  update()
}


function getSyncStatus() {
  const eLinkData = currentELinkData.value

  if (eLinkData?.strategy_type) {
    let key = "strategys_" + eLinkData.strategy_type
    let eMindDataSource = eLinkData[key]
    let isSync = compareStrategy(eMindDataSource, eLinkData.strategys_current)
    let isDemandEqual = eLinkData.demand_current === eLinkData.demand
    let emd_isCtl = !!(eLinkData.third_ctl_en * 1)
    let elk_isCtl = !!(eLinkData.third_ctl_en_current * 1)
    let isEq = emd_isCtl === elk_isCtl
    if (isSync && isDemandEqual /* && isEq */) {
      return true
    }
  }
  return false
}



function onSwitchBeforeChange(value) {
  // 标记加载中
  strategyState.allowDispatchLoading = true;
  // 显示确认弹窗
  ElMessageBox.confirm($str.getKey('策略控制/是否确认切换第三方调度状态？'), $str.getKey('策略控制/系统提示'), {
    confirmButtonText: $str.getKey('策略控制/确认'),
    cancelButtonText: $str.getKey('策略控制/取消'),
    type: "warning"
  }).then(() => {
    // 用户点击确认，调用API保存更改
    onThirdCtlEnConfirm().then(() => {
      // API调用成功，状态已在API中更新
      console.log('第三方调度状态已切换');
      strategyState.allowDispatchLoading = false;
    })
  }).catch(() => {
    // 用户点击取消，恢复原始状态
    strategyInfo.allowVirtualDispatch = !value;
    strategyState.allowDispatchLoading = false;
  });
}

function onChargeModeCancel() {
  strategyState.chargeModeDrawerVisible = false
}

function onChargeModeConfirm() {
  strategyState.chargeModeDrawerVisible = false

  let elk = {
    id: currentELinkData.value.id,
    elink_id: selectedELink.value,
    week_plan: strategyState.inputChargeMode,
    station_id: appStore.stationId,
    opt_user: userStore.name,
  }

  strategyApi.updatePlan(elk).then((res) => {
    if (res.code == 200) {
      window.dispatchNotify({
        type: 'success',
        message: $str.getKey('策略控制/计划修改成功')
      });
      pullStrategy()
    }
  })
}

function onThirdCtlEnConfirm() {
  return new Promise((resolve, reject) => {
    const postData = {
      id: currentELinkData.value.id,
      elink_id: selectedELink.value,
      station_id: appStore.stationId,
      station_name: appStore.stationName,
      opt_user: userStore.name,
      third_ctl_en: toBinStr(strategyInfo.allowVirtualDispatch),
    }

    strategyApi.updatePlan(postData).then(() => {
      window.dispatchNotify({
        type: 'success',
        message: $str.getKey('策略控制/切换成功')
      });
      pullStrategy()
      resolve()
    })
  })

}


function onRunStrategyCancel() {
  sEditRef.value.exitEdit()
}


async function onRunStrategyConfirm() {
  const strategys = sEditRef.value.getStrategys(false)
  const valid = sEditRef.value.checkValidate()
  if (!valid) {
    return
  }

  if (strategys.work.length == 0) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/工作日策略不能为空')
    });
    return
  }

  if (strategys.rest.length == 0) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/休息日策略不能为空')
    });
    return
  }

  // 判断防逆流值是否发生变化：编辑器初始化时用了 `|| 0` 兜底，这里对齐同样处理
  const originWorkDemand = Number(currentELinkData.value.demand_min_weekday) || 0
  const originRestDemand = Number(currentELinkData.value.demand_min_weekend) || 0
  const demandChanged =
    Number(strategys.workDemandMin) !== originWorkDemand ||
    Number(strategys.restDemandMin) !== originRestDemand

  // 仅当分组电站且防逆流值确实被修改时，才需要携带短信验证码
  const needSmsCode = groupedElinkList.value.length > 0 && demandChanged

  // 只有在需要验证码时才取用；并先校验其有效性，过期的直接丢弃，
  // 避免带着失效验证码触发后端返回“验证码已失效”
  let smsCode = ''
  if (needSmsCode) {
    smsCode = (await sEditRef.value.getVerificationCode()) || ''
    // 需要验证码却没有有效验证码，提示重新验证，避免带空/失效码下发
    if (!smsCode) {
      window.dispatchNotify({
        type: 'warning',
        message: $str.getKey('策略控制/请先完成短信验证')
      });
      return
    }
  }

  // 待提交的数据
  let putObj = {
    id: currentELinkData.value.id,
    elink_id: selectedELink.value,
    station_id: appStore.stationId,
    station_name: appStore.stationName,
    strategys_work: strategys.work,
    strategys_rest: strategys.rest,
    opt_user: userStore.name,
    demand_min_weekday: strategys.workDemandMin,
    demand_min_weekend: strategys.restDemandMin
  }
  // 不涉及防逆流变更时，不下发防逆流字段，也不携带验证码
  if (!needSmsCode) {
    delete putObj.demand_min_weekday
    delete putObj.demand_min_weekend
  }
  const loading = proxy.$loading({
    lock: true,
    text: $str.getKey('策略控制/保存中...'),
    background: 'rgba(0, 0, 0, 0.7)'
  })

  strategyApi.updatePlan(putObj, smsCode).then((res) => {
    if (res.code == 200) {
      window.dispatchNotify({
        type: 'success',
        message: $str.getKey('策略控制/修改成功')
      });
      pullStrategy()
      strategyState.runStateIsEdit = false
    } else {
      // 后端提示验证码失效时，清除本地缓存的过期验证码（连同时间戳一并清理）
      if (res.code === 401 || res.msg?.includes('验证码')) {
        clearSmsCode()
      }
      window.dispatchNotify({
        type: 'error',
        message: res.msg
      });
      updateELinks()
    }
  }).catch(e => {
    console.warn(e)
  }).finally(() => {
    loading.close()
  })
}

function onAppointmentRemove(value) {
  if (value.id != null) {
    strategyApi.deleteCustomStrategy(value.id, userStore.name).then(r => {
      if (r.code == 200) {
        window.dispatchNotify({
          type: 'success',
          message: $str.getKey('策略控制/删除') + `${value.custom_strategy_name}` + $str.getKey('策略控制/成功')
        });
        // appointmentList.value = appointmentList.value.filter(it => it.id !== value.id)
        updateCustomStrategys()
      }
    })
  } else {
    appointmentList.value = appointmentList.value.filter(it => it.id)
  }
}

function onAppointmentCancelEdit(id) {
  if (!id) {
    appointmentList.value = appointmentList.value.filter(item => item.id)
  }
}

function addAppointment() {
  if (appointmentList.value.length >= 15) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/最多可增加15条预约策略')
    });
    return
  }
  if (appointmentList.value.length == 0) {
    appointmentList.value.push(Appointment())
    return
  }
  let last = appointmentList.value.at(-1)
  if (last && last.id) {
    const index = appointmentList.value.length + 1
    appointmentList.value.push(Appointment(index))
  } else {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/请先保存') + `${last?.custom_strategy_name}`
    });
  }
}

function onAppointmentCancel() {
  strategyState.appointmentDrawerVisible = false
}

function onAppointmentConfirm() {
  strategyState.appointmentDrawerVisible = false
}


async function init() {

  /**
   * 电站切换时刷新eLink数据,并且选择第1个eLink
   */
  watch(stationId, async () => {
    await updateELinks()
    await selectFirst()
    getTempature()
  })

  /**
   * eLink切换时更新自定义策略
   */
  watch(selectedELink, async () => {
    await updateCustomStrategys()
    getTempature()
  })

  watch(currentELinkData, (value) => {
    strategyInfo.allowVirtualDispatch = !!(value?.third_ctl_en * 1)
  })



  await updateELinks()
  await selectFirst()



}

function getTempature() {
  strategyApi.getTempatureOption(selectedELink.value).then((res) => {
    if (res && res.data && res.data[0]) {
      realDemand.value = Number(res.data[0].demand_min);
      antiReflux.value = res && res.data && Number(res.data[0].demand_min) > -60000
    } else {
      realDemand.value = null
      antiReflux.value = true
    }
  })
}

init()

/** 检查输入的需量值,小数自动取整 */
function checkInputDemand() {
  const v = strategyState.inputDemand;
  if (/^\d+\.\d+$/.test(v)) {
    window.dispatchNotify({
      type: 'info',
      message: $str.getKey('策略控制/需量不允许设置小数,已自动为您取整')
    });
    strategyState.inputDemand = Math.round(v);
  }
}

/** 根据index设置预约策略卡片header中的icon */
function getIconImg(index) {
  if (index % 3 === 0) {
    return icon0;
  }
  if (index % 3 === 1) {
    return icon1;
  }
  if (index % 3 === 2) {
    return icon2;
  }
  return icon0;
}
const realDemand = ref(null)
const antiReflux = ref(false)
const antiRefluxLoading = ref(false)
function onSwitchBeforeChangeAntiReflux() {
  return new Promise((resolve, reject) => {
    let demandData = 0;
    if (Number(realDemand.value) > -60000) {
      antiReflux.value = false;
      demandData = Number(realDemand.value) - 65535;

    } else {
      antiReflux.value = true;
      demandData = Number(realDemand.value) + 65535;
    }
    antiRefluxLoading.value = true
    strategyApi.setTempatureOption({
      demand_min: demandData,
      dev_id: selectedELinkDevId.value,
      station_id: String(stationId.value),
      uuid: selectedELink.value
    }).then((res) => {
      if (res && res.code == 200) {
        antiRefluxLoading.value = false
        resolve();
        setTimeout(() => {
          getTempature()
          window.dispatchNotify({
            type: 'success',
            message: $str.getKey('全局/设置成功')
          });
        }, 2500)
      }
    })


  })
}

// 选择分组
function selectGroup(index) {
  // 先设置选中的分组索引
  selectedGroupIndex.value = index

  // 获取该分组内的所有eLink
  const groupLinks = currentGroupElinkList.value
  if (groupLinks.length === 0) return

  // 检查当前分组中是否已有选中的eLink
  const hasSelectedElinkInGroup = groupLinks.some(eLink => eLink.uuid === selectedELink.value)

  // 如果该分组内没有选中的eLink,则选中第一个
  if (!hasSelectedElinkInGroup) {
    const firstELink = groupLinks[0]
    if (firstELink) {
      onButtonClick(firstELink.uuid, firstELink.dev_id, getElinkName(firstELink.uuid))
    }
  }
}


// 获取分组需量
function getGroupDemand(group) {

  const firstDemand = group.eLinkSettingList[0].demandMax || 0

  return `${firstDemand || 0}kW`
}

// 开始编辑分组需量
function onEditGroupDemand(groupIndex) {
  const group = groupedElinkList.value[groupIndex]

  groupDemandValue.value = group.eLinkSettingList[0].demandMax || 0

  editingGroupIndex.value = groupIndex
}

// 取消编辑分组需量
function onCancelGroupDemand() {
  editingGroupIndex.value = null
}

// 确认修改分组需量
async function onConfirmGroupDemand(groupIndex) {
  if (groupDemandValue.value <= 0) {
    window.dispatchNotify({
      type: 'info',
      message: '需量必须大于0'
    });
    return
  }

  const group = groupedElinkList.value[groupIndex].eLinkSettingList
  const uuidList = group.map(item => item.uuid)
  strategyApi.updateGroupSetting({
    stationId: stationId.value,
    uuidList: uuidList,
    demandMax: groupDemandValue.value
  }).then((res) => {
    if (res && res.code == 200) {
      onCancelGroupDemand()
      setTimeout(() => {
        updateELinks()
        window.dispatchNotify({
          type: 'success',
          message: $str.getKey('全局/修改成功')
        });
      }, 2500)
    }
  })
}

function checkGroupDemandValue() {
  
  const v = groupDemandValue.value;
  if (v <= 0) {
    window.dispatchNotify({
      type: 'info',
      message: '需量必须大于0'
    });
    groupDemandValue.value = 1000;
    return;
  }

  if (/^\d+\.\d+$/.test(v)) {
    window.dispatchNotify({
      type: 'info',
      message: '需量不允许设置小数,已自动为您取整'
    });
    groupDemandValue.value = Math.round(v);
  }
}

/**获取eLinkname */
function getElinkName(elinkId) {
  const elink = eLinkList.value.find(elink => elink.elink_id === elinkId);
  return elink ? elink.elink_name : '';
}

// 根据入参展示按钮上的文字展示，flag为true时不展示需量，false时展示需量
function getBtnText(uuid,deminaMax,flag){
  
  let name = getElinkName(uuid)
  if(!flag){
    return name
  }else{
    return `${name}  需量:${deminaMax}kW`
  }
  
  
}

const demandHistoryDrawerVisible = ref(false)

</script>

<style lang='scss' scoped>
.strategy-page-container {
  width: 100%;
  min-height: 560px;
  height: 100%;
  display: flex;
  flex-direction: column;
  $top-container-height: 100px;
  padding: 10px;

  .group-container {
    background: #FFFFFF;
    border-radius: 20px;
    padding: 10px;
    margin-bottom: 10px;

    .title-text {
      // border-left: 4px solid #485E91;
      // padding-left: 16px;
      font-family: HelveticaNeue, HelveticaNeue;
      font-weight: bold;
      font-size: 18px;
      line-height: 23px;
      text-align: left;
      margin-bottom: 10px;
      color: #2E2E2E;

      .tip-icon {
        color: #D0D1D2;
      }
    }

    .group-blocks-container {
      display: flex;
      flex-flow: row;
      overflow-x: auto;
      padding-bottom: 6px;
      overflow-y: hidden;

      &::-webkit-scrollbar {
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #F6FAFF;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-track {
        background-color: #F6FAFF;
        border-radius: 4px;
      }

      .group-card {
        width: auto;
        /* 固定宽度 */
        min-width: 320px;
        /* 最小宽度 */
        flex-shrink: 0;
        /* 防止卡片被压缩 */
        background: #F6FAFF;
        border-radius: 8px;
        padding: 12px;
        cursor: pointer;
        transition: all 0.3s;
        border: 1px solid #F4F7FC;
        display: flex;
        flex-direction: column;
        margin-right: 15px;
        /* 卡片之间的间距 */

        &.active {
          background: #F6FAFFE5;
          box-shadow: 0px 4px 14.5px 0px #0000000D;


          .elink-btn {
            background: rgba(62, 74, 98, 1);
            color: #2E2E2E;

            &.active {
              background: #FFFFFF;
              color: #4e73ff;
            }
          }
        }

        &:hover:not(.active) {
          background: #F6FAFFE5;
        }

        .card-header {
          display: flex;
          align-items: center;
          margin-bottom: 16px;

          .card-index {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 24px;
            height: 24px;
            background: #CFCFCF;
            color: #fff;
            border-radius: 50%;
            font-weight: bold;
            font-size: 14px;
            margin-right: 10px;

            &.active {
              background: #2E2E2E;
            }
          }

          .group-name {
            font-weight: bold;
            font-size: 15px;
            color: #2E2E2E;
          }
        }

        .card-content {
          margin-bottom: 16px;

          .demand-row {
            height: 32px;
            display: flex;
            align-items: center;

            .demand-label {
              font-size: 14px;
              color: #2E2E2E;
              margin-right: 8px;
              font-weight: 400;
            }

            .demand-value {
              font-size: 14px;
              color: #2E2E2E;
              font-weight: 600;
              flex: 1;
            }

            .demand-input {
              flex: 1;
              margin-right: 10px;
              width: 100px;

              :deep(.el-input-number) {
                width: 100%;
              }
            }

            .demand-actions {
              display: flex;
              gap: 8px;
              margin-left: auto;

              button {
                margin: 0;
                padding: 4px 12px;
                font-size: 12px;
                cursor: pointer;
                transition: all 0.2s ease;

                &:hover {
                  opacity: 0.9;
                }
              }

              .btn-modify {
                height: 21px;
                background: #F6FAFFE5;
                color: #3A68FF;
                border: none;
                box-shadow: none;
                border: 1px solid #3A68FF;
              }

              .btn-confirm {
                height: 21px;
                background: #3A68FF;
                color: #FFFFFF;
                // border: none;
              }

              .btn-cancel {
                height: 21px;
                background: #F4F7FC;
                color: #2E2E2EB2;
                // border: none;
              }
            }
          }
        }

        .elink-buttons {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;

          .elink-btn {
            padding: 5px 12px;
            border-radius: 10px;
            background: #F0F6FF;
            color: #2E2E2E;
            font-size: 13px;
            border: none;
            cursor: pointer;
            transition: all 0.2s ease;

            &.active {
              background: #3A68FF1A;
              color: #4D66F3;
            }

            &:hover:not(.active) {
              opacity: 0.9;
            }
          }
        }
      }
    }
  }

  .top-container {
    min-height: $top-container-height;
    padding: 10px;
    background: #FFFFFF;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .title-text {
      border-left: 4px solid #485E91;
      padding-left: 16px;
      font-family: HelveticaNeue, HelveticaNeue;
      font-weight: bold;
      font-size: 18px;
      line-height: 23px;
      text-align: left;
    }

    .tab-btns-container {
      padding: 20px 0;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      .strategy-btn {
        // width: 88px;
        height: 32px;
        background: #EFF4FB;
        border-color: #EFF4FB;
        border-radius: 10px;
        margin-left: 0;
        &:hover {
          color: #2E2E2E;
        }
      }
    }
  }

  .main-container {
    width: 100%;
    min-height: calc(100% - $top-container-height);
    flex: 1 1 calc(100% - $top-container-height);
    display: flex;
    flex-wrap: nowrap;
    margin-top: 10px;
    gap: 12px;

    .left-container {
      height: 100% !important;

      flex: 1 1 calc(100% - 392px);
      min-width: 0;
      border-radius: 6px;
      background: #FFFFFF;
      padding: 20px;

      &.switch-on {
        height: 100%;

        .chart-info-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 8px;

          .infos {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px 0;

            .title-text {
              margin-right: 20px;
              font-family: PingFang-SC, PingFang-SC;
              font-weight: bold;
              font-size: 16px;
              color: #2E2E2E;
              line-height: 23px;
              text-align: left;
            }
          }
        }

        .chart-container {
          width: 100%;
          height: 95%;

          &.is-compare {
            display: flex;
            flex-direction: column;
            height: 600px;
            &.chart-bepartof-group {
              height: 680px;
            }

            .chart-comp {
              box-sizing: border-box;
              width: 100%;
              height: 95%;
              // flex: 1 1 50%;
              padding-bottom: 10px;
            }
          }

          &.no-compare {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            width: 100%;
            height: 600px;
            // flex: 1 1 50%;
            padding-bottom: 10px;

            &.chart-bepartof-group {
              height: 680px;
            }

            .echarts {
              width: 100%;
              height: 100%;
            }

          }
        }
      }

      &.switch-off {
        height: 100%;
      }
    }

    .right-container {
      width: 380px;
      flex: 0 1 380px;
      min-width: 0;
      background: #FFFFFF;
      border-radius: 20px;
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 20px;

      overflow: hidden;

      .title-text {
        color: #2E2E2E;
        font-size: 16px;
        font-weight: 400;
      }

      .module-card {
        min-height: 90px;
        background: linear-gradient(to right, #E7EDFF, #FFFFFF);
        border-radius: 10px;
        padding: 12px 14px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        &.edit-container {
          width: 300px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          gap: 6px;
          .input-dom {
            flex: 1;
          }
          .btns {
            flex: 1;
            display: flex;
            align-items: center;
            gap: 6px;
            .btn {
              margin: 0;
            }
          }
        }


        .content-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 10px;
          color: #2E2E2E;
          font-size: 14px;

          .value {
            color: #2E2E2E;
            font-size: 14px;
            font-weight: 500;
          }

          .desc-info {
            font-size: 12px;
            color: #2E2E2E99;
          }
          .interaction {
            min-width: 60px;
            display: flex;
            justify-content: flex-end;
            .inter-btn {
              font-size: 12px;
              color: #2E2E2E;
              height: 24px;
            }
          }
        }
      }

      .moudle-gather-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 10px;

        .module-enter-btn {
          width: 100%;
          height: 33px;
          margin: 0;
          overflow: hidden;

          .btn-wrapper {
            position: relative;
            display: flex;
            align-items: center;
            gap: 6px;
            .module-icon {
              width: 12px;
              height: 12px;
            }
            .module-title-container {
              display: flex;
              align-items: center;
              gap: 2px;
            }
          }
        }
      }
    }
  }
}

// 设置甘特图tootip的样式
:deep(.chart-tooltip) {
  background: #FFFFFFEE !important;
  
  .chart-tooltip__series {
    margin: 10px 0;
    padding: 10px;
  }
}


</style>


<style lang="scss">
.el-overlay.is-drawer.el-modal-drawer {
  opacity: 1 !important;
  -webkit-backdrop-filter: blur(5px) !important;
  backdrop-filter: blur(5px) !important;
  background: linear-gradient(109deg, #01010180 1.53% 98.28%) !important;
}
.cus-drawer-20241114-143756.el-drawer {
  width: 80vw !important;
  max-width: 1920px !important;
  border-radius: 30px 0 0 30px !important;
  height: 100% !important;
  max-height: 100vh !important;
  margin: 0 !important;
  background-color: #fff !important;
  background: url('@/assets/images/station-monitor/detail-dialog/detail-bg.svg') no-repeat center center;
  background-size: cover;
  display: flex !important;
  flex-direction: column !important;

  .el-drawer__header {
    margin: 0;
    flex-shrink: 0;
  }

  .el-drawer__body {
    background: #F6FBFF;
    margin: 0 20px;
    border-radius: 30px;
    flex: 1 1 auto;
    min-height: 0;
    overflow: auto;
  }

  .el-drawer__title {
    font-size: 20px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 20px;
    padding-left: 26px;
  }
  .el-drawer__close {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    position: absolute;
    top: 16px;
    right: 24px;
    &:hover {
      background: #e2e4e788;
    }
  }


  &.appointment-drawer {
    .el-alert--info.is-light {
      background: transparent;
    }

    .appointment-wrapper {
      background: #F6FBFF;
      padding: 10px 10px 30px 10px;
      border-radius: 30px;

      .cards-container {
        margin: 16px 26px;
        display: grid;
        grid-auto-flow: row dense;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 20px 24px;

        .card {
          height: 350px;
          border-radius: 6px;
        }

        .add-card {
          background: #EFF4FBB2;
          height: 350px;
          border-radius: 20px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          gap: 10px;

          .add-img {
            width: 95px;
            height: 95px;
            border-radius: 50%;
            background-color: #E6EFFC;
            background-image: url('@/assets/images/strategy/add.svg');
            background-repeat: no-repeat;
            background-position: center;
          }

          .add-text {
            font-family: PingFang-SC, PingFang-SC;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            text-align: center;
          }

          &:hover {
            .add-img {
              background-color: #c0d3d299;
            }
            cursor: pointer;
          }
        }
      }
    }
  }

  .communication-mode-container {
    padding: 0 20px;

    .mode-selection {
      background: #1F2536;
      border-radius: 8px;
      padding: 20px;

      .title {
        font-size: 16px;
        font-weight: bold;
        color: #2E2E2E;
        margin-bottom: 20px;
      }

      .mode-options {
        margin-bottom: 20px;

        .el-radio {
          margin-right: 20px;
          margin-bottom: 10px;
          color: #D0D0D0;
        }

        .el-radio__input.is-checked+.el-radio__label {
          color: #409EFF;
        }
      }

      .mode-description {
        background: #2E3648;
        border-radius: 8px;
        padding: 16px;

        .subtitle {
          font-size: 14px;
          font-weight: bold;
          color: #2E2E2E;
          margin-bottom: 10px;
        }

        .desc-text {
          font-size: 13px;
          color: #97A0B7;
          line-height: 1.6;

          .sub-item {
            margin-top: 10px;

            .sub-item-title {
              font-weight: bold;
              color: #D0D0D0;
              margin-bottom: 4px;
            }

            .sub-item-desc {
              padding-left: 15px;
              margin-bottom: 8px;
            }
          }
        }
      }
    }
  }
}
</style>
